module.exports = __webpack_public_path__ + "img/image (29).ad4e76ea.jpg";